// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"589":"57fa8e9d","791":"3ac8f02b","898":"8257ec11"}[chunkId] + ".chunk.css";
};